export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/keypointsMergerWorker.34d31ce5.worker.js");
}
